module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/components/notification/types/types.component.css
// module id = ./src/app/components/notification/types/types.component.css
// module chunks = main